import { useState } from 'react';
import useSWR from 'swr';
import config from '../config';

const { apiUrl } = config;
const apiPath = 'projects';

const fetcher = ([path, user]) => {
  if (!path || !user) {
    throw new Error(`useProjects: Bad URL ${apiUrl}/${path}/${user}`);
  }
  return fetch(`${apiUrl}/${path}/${user || ''}`, {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'test',
    },
    mode: 'cors',
  })
    .then((res) => res.json())
    .then((data) => data.items.map((item) => {
      const {
        // eslint-disable-next-line no-shadow
        languages, project, user, description, defaultLang,
      } = item;
      return {
        project, user, description, languages, defaultLang,
      };
    }))
    .catch((err) => {
      console.error(
        `useProjects: Failed to fetch - error: ${err} - url: ${apiUrl}/${path}/${user}`,
      );
      return Promise.reject(new Error('useProjects: Failed to fetch'));
    });
};

export default function useProjects({ user }) {
  console.log(`UseProjects/user: ${user}`);
  const [currentProject, setCurrentProject] = useState('');
  const {
    data, isLoading, error, mutate,
  } = useSWR([apiPath, user], fetcher);

  /*  const projects = () => fetch(
    `${apiUrl}/${apiPath}/${user}`,
    {
      headers: {
        'Content-type': 'application/json',
        Accept: 'application/json',
        Authorization: 'test',
      },
    }
  ).then((response) => {
    console.log(`Get Projects response is ${response}`);
  });
*/

  const addProject = async (projectData) => fetch(`${apiUrl}/${apiPath}/`, {
    headers: {
      'Content-type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      Accept: 'application/json',
      Authorization: 'test',
    },
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify({
      user,
      ...projectData,
    }),
  }).then((response) => {
    if (response.ok) {
      console.debug('mutate');
      setCurrentProject(projectData.project);
      mutate();
    }
  });

  const deleteProject = (key) => fetch(`${apiUrl}/${apiPath}/${user}/${key}`, {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'test',
    },
    method: 'DELETE',
    mode: 'cors',
  }).then((response) => {
    if (response.ok) {
      console.log('mutate');
      mutate();
    }
  });

  const updateProject = (key, projectData) => fetch(`${apiUrl}/${apiPath}/${user}/${key}`, {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'test',
    },
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify({
      ...projectData,
    }),
  }).then((response) => {
    if (response.ok) {
      console.log('updated');
      mutate();
    }
  });

  return {
    projects: data,
    isLoading,
    isError: error,
    addProject,
    deleteProject,
    updateProject,
    currentProject,
    setCurrentProject,
  };
}
